import { Table, Button, Container, Row, Col, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark, faWrench, faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";

const DeviceTable = ({ devices, loading, onEditDevice, onAddNewDevice }) => {
    if (loading) {
        return (
            <div className="text-center my-5">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    if (!devices || devices.length === 0) {
        return (
            <Container fluid>
                <Row className="mb-3">
                    <Col md={12} className="text-md-end">
                        <Button variant="primary" onClick={onAddNewDevice}>
                            Add a New Device
                        </Button>
                    </Col>
                </Row>
                <div className="alert alert-info">No devices found</div>
            </Container>
        );
    }

    const renderStatusIcon = (status) => {
        switch (status) {
            case 'active':
                return <FontAwesomeIcon icon={faCircleCheck} className="text-success me-2" title="active" />;
            case 'inactive':
                return <FontAwesomeIcon icon={faCircleXmark} className="text-danger me-2" title="inactive" />;
            case 'maintenance':
                return <FontAwesomeIcon icon={faWrench} className="text-warning me-2" title="maintenance" />;
            default:
                return null;
        }
    };

    return (
        <>
            <Row>
                <Col md={12} className="text-md-end">
                    <Button
                        variant="primary"
                        onClick={onAddNewDevice}
                        className="mt-5"
                    >
                        <FontAwesomeIcon icon={faPlus} className="me-2" />
                        Add New
                    </Button>
                </Col>
            </Row>
            <h2 className="mb-4 fs-2">Devices</h2>
            <Table  striped bordered hover responsive>
                <thead className="table-striped">
                    <tr>
                        <th>#</th>
                        <th>Device ID</th>
                        <th>Device Name</th>
                        <th>Device Status </th>
                        <th>Description</th>
                        <th>Created</th>
                        <th>Updated</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {devices && devices.length > 0 ? (
                        devices.map((device, index) => (
                            <tr key={device.device_id || index}>
                                <td>{index + 1}</td>
                                <td>{device.device_id}</td>
                                <td>{device.name}</td>
                                <td>{renderStatusIcon(device.status)} {device.status}</td>
                                <td>{device.device_description || '-'}</td>
                                <td>
                                    {new Date(device.created_at).toLocaleDateString()}
                                    <br />
                                    <small className="text-muted">
                                        {new Date(device.created_at).toLocaleTimeString()}
                                    </small>
                                </td>
                                <td>
                                    {device.updated_at ? (
                                        <>
                                            {new Date(device.updated_at).toLocaleDateString()}
                                            <br />
                                            <small className="text-muted">
                                                {new Date(device.updated_at).toLocaleTimeString()}
                                            </small>
                                        </>
                                    ) : (
                                        "-"
                                    )}
                                </td>
                                <td align="center">
                                    <Button
                                        variant="warning"
                                        onClick={() => onEditDevice(device)}
                                        size="sm"
                                        title="Edit"
                                    >
                                        <><FontAwesomeIcon icon={faEdit}/></>
                                    </Button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" className="text-center text-muted py-4"> No devices added yet. </td>
                        </tr>
                    )}
                </tbody>
            </Table>

            <div className="d-flex justify-content-end mt-3 me-3">
				<span className="text-muted"> Showing {devices?.length || 0} records </span>
			</div>
        </>
    );
};

export default DeviceTable;